import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-alert-message',
	templateUrl: './alert-message.component.html',
	styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {

	@Input() alertType: 'success' | 'confirm' | 'error' | 'warning' | 'warning-v2' | 'info';
	@Input() message: string;
	@Input() title: string;
	@Input() boldText: string;
	@Input() showActions = false;
	@Output() action = new EventEmitter();

	constructor() {
	}

	ngOnInit(): void {
	}

	actionClick() {
		this.action.next(null);
	}

}
